export const safeNullDataset = dataObj => fields => {
  const fieldsArray = Object.prototype.toString.call(fields) === '[object Array]';

  if (dataObj && fieldsArray) {
    return fields.reduce((acc, field) => {
      return acc[field] ? acc[field] : [];
    }, dataObj);
  }

  return dataObj && dataObj[fields] ? dataObj[fields] : [];
};
